export default function Details() {
  return (
    <section id="details" className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            開催概要
          </h3>
          <p className="text-lg text-gray-600">
            セミナーの詳細情報をご確認ください
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* プログラム */}
          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                <i className="ri-calendar-check-line text-2xl text-teal-600"></i>
              </div>
              <h4 className="text-2xl font-bold text-gray-900">プログラム</h4>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-20 h-20 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-blue-600 font-bold text-lg">1部</span>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <h5 className="font-bold text-gray-900">「なんであの人はわかってくれないの?」が「そうだったのか!」に変わる</h5>
                  </div>
                  <p className="text-sm text-blue-600 font-semibold mb-2">
                    <i className="ri-time-line mr-1"></i>13:30 - 14:30
                  </p>
                  <p className="text-sm text-gray-700 font-medium mb-2">
                    <i className="ri-user-line mr-1"></i>講師:福井秀延
                  </p>
                  <p className="text-sm text-gray-600">
                    占い診断で紐解く、自分と相手の取扱説明書
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-20 h-20 bg-teal-50 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-teal-600 font-bold text-lg">2部</span>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <h5 className="font-bold text-gray-900">ビジョンマップ</h5>
                  </div>
                  <p className="text-sm text-teal-600 font-semibold mb-2">
                    <i className="ri-time-line mr-1"></i>14:40 - 16:40
                  </p>
                  <p className="text-sm text-gray-700 font-medium mb-2">
                    <i className="ri-user-line mr-1"></i>講師:櫻井ゆみ
                  </p>
                  <p className="text-sm text-gray-600">
                    あなたの夢や目標を視覚化し、実現への道筋を明確にします
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-20 h-20 bg-purple-50 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-purple-600 font-bold text-lg">3部</span>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <h5 className="font-bold text-gray-900">質問タイム</h5>
                  </div>
                  <p className="text-sm text-purple-600 font-semibold mb-2">
                    <i className="ri-time-line mr-1"></i>16:40 - 17:00
                  </p>
                  <p className="text-sm text-gray-600">
                    講師への質問や疑問点を解消する時間です
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Left: Details */}
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-8 rounded-2xl">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-event-line text-2xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">日程</h4>
                  <p className="text-2xl font-bold text-teal-600">2025年12月28日（日）</p>
                </div>
              </div>

              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">時間</h4>
                  <p className="text-xl font-bold text-gray-900">13:30 - 17:00</p>
                  <p className="text-gray-600 mt-1">受付開始：13:00</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h4 className="text-lg font-bold text-gray-900 mb-2">場所</h4>
                  <p className="text-lg font-bold text-gray-900 mb-2">アデニウムタワー梅田</p>
                  <p className="text-gray-600">
                    〒530-0043<br />
                    大阪市北区本庄東1-23-2
                  </p>
                  <div className="mt-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
                    <p className="text-sm text-gray-700">
                      <i className="ri-information-line text-blue-600 mr-1"></i>
                      マンションに到着されましたらインターホンで「2505」を押下いただき、25階までお上がり下さい。
                    </p>
                  </div>
                  <a 
                    href="https://www.google.com/maps/search/?api=1&query=大阪市北区本庄東1-23-2"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-700 mt-3 cursor-pointer"
                  >
                    <i className="ri-map-2-line"></i>
                    <span className="whitespace-nowrap">地図を見る</span>
                  </a>
                </div>
              </div>
            </div>

            {/* 持ち物 */}
            <div className="bg-white border-2 border-gray-200 p-8 rounded-2xl">
              <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-shopping-bag-line text-teal-600"></i>
                持ち物
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-1"></i>
                  <span className="text-gray-700">はさみ</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-1"></i>
                  <span className="text-gray-700">のり</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-1"></i>
                  <span className="text-gray-700">自分の好きな雑誌やカタログ<br />（切り抜いてもいいもの）</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-1"></i>
                  <span className="text-gray-700">筆記用具</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-1"></i>
                  <span className="text-gray-700">飲み物<br />（建物内に自動販売機はありません）</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Right: Map & Additional Info */}
          <div className="space-y-6">
            {/* Google Map */}
            <div className="bg-gray-100 rounded-2xl overflow-hidden h-80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3279.5234567890!2d135.5147!3d34.7145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e6f3c3c3c3c3%3A0x0!2z5aSn6Ziq5biC5YyX5Yy65pys5bqE5p2x77yR5LiB55uu77yS77yT4oiS77yS!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="会場地図"
              ></iframe>
            </div>

            {/* アクセス */}
            <div className="bg-gradient-to-br from-blue-50 to-teal-50 p-8 rounded-2xl">
              <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-train-line text-teal-600"></i>
                アクセス
              </h4>
              <div className="space-y-3 text-gray-700">
                <p className="flex items-start gap-2">
                  <i className="ri-subway-line text-teal-600 mt-1"></i>
                  <span>大阪メトロ地下鉄 天神橋筋六丁目駅から徒歩5分</span>
                </p>
                <p className="flex items-start gap-2">
                  <i className="ri-map-pin-2-line text-teal-600 mt-1"></i>
                  <span>住所：大阪府大阪市北区本庄東1-23-2アデニウムタワー梅田イーストスクエア</span>
                </p>
              </div>
            </div>

            {/* 参加費 */}
            <div className="bg-gradient-to-br from-teal-600 to-blue-600 p-8 rounded-2xl text-white">
              <h4 className="text-xl font-bold mb-4 flex items-center gap-2">
                <i className="ri-price-tag-3-line"></i>
                参加費
              </h4>
              <div className="space-y-6">
                {/* 1部 */}
                <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
                  <div className="text-center">
                    <div className="text-sm mb-2 opacity-90">1部のみ</div>
                    <div className="text-4xl font-bold mb-1">¥4,000</div>
                    <div className="text-xs opacity-90">（税込）</div>
                    <a 
                      href="https://chois.jp/20251228-1/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-4 block w-full bg-white text-blue-600 px-6 py-3 rounded-full hover:bg-gray-100 transition-colors font-bold text-center cursor-pointer whitespace-nowrap"
                    >
                      お申し込みはこちら
                    </a>
                  </div>
                </div>
                
                {/* 2部 */}
                <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl">
                  <div className="text-center">
                    <div className="text-sm mb-2 opacity-90">2部のみ</div>
                    <div className="text-4xl font-bold mb-1">¥4,000</div>
                    <div className="text-xs opacity-90">（税込）</div>
                    <a 
                      href="https://chois.jp/20251228-2/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-4 block w-full bg-white text-teal-600 px-6 py-3 rounded-full hover:bg-gray-100 transition-colors font-bold text-center cursor-pointer whitespace-nowrap"
                    >
                      お申し込みはこちら
                    </a>
                  </div>
                </div>
                
                {/* 1部+2部セット */}
                <div className="bg-white/20 backdrop-blur-sm p-6 rounded-xl border-2 border-white/50">
                  <div className="text-center">
                    <div className="text-sm mb-2 font-semibold">1部+2部セット</div>
                    <div className="text-5xl font-bold mb-1">¥5,000</div>
                    <div className="text-xs opacity-90">（税込）</div>
                    <div className="mt-3 text-sm bg-yellow-400 text-gray-900 px-4 py-1 rounded-full inline-block font-semibold">
                      お得！
                    </div>
                    <a 
                      href="https://chois.jp/map1228/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-4 block w-full bg-white text-teal-600 px-6 py-3 rounded-full hover:bg-gray-100 transition-colors font-bold text-center cursor-pointer whitespace-nowrap"
                    >
                      お申し込みはこちら
                    </a>
                  </div>
                </div>
              </div>
              <div className="mt-6 pt-6 border-t border-white/20">
                <p className="text-sm text-center opacity-90">
                  ※定員になり次第、受付を終了いたします
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}